import { render, staticRenderFns } from "./List-Employees.vue?vue&type=template&id=be4b5cb2"
import script from "./List-Employees.vue?vue&type=script&lang=js"
export * from "./List-Employees.vue?vue&type=script&lang=js"
import style0 from "./List-Employees.vue?vue&type=style&index=0&id=be4b5cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports